import React, {useEffect, useState} from 'react';
import './style.scss';
import {BottomNav, Coins, FriendCard, TaskCard} from '../../components';
import profileCardDefault from '../../../images/profile-card-default.png';
import taskInvite from '../../../images/task-invite.jpg';
import {APP_PRIZE_COINS} from '../../constants';
import {PopupTaskInvite} from '../Home/components';
import {useCurrentUser} from '../../layouts/UserContext';
import {CommonUtil} from '../../utils/CommonUtil';
import axios from 'axios';

const POPUP_NAME = {
    TASK_INVITE: 'task_invite',
}

export const FriendsPage = () => {
    const {user} = useCurrentUser();
    const [popupName, setPopupName] = useState(null);
    const [friends, setFriends] = useState([]);
    const [score, setScore] = useState(0);

    useEffect(() => {
        CommonUtil().ymReachGoal('ladybug_game_view_friends');
        console.log('[Ladybug.Friends] > ready')
        axios.post('https://lovi-kwami.tv3.ru/api/ladybug-game/friends', {
                hash: user.authToken,
            })
            .then(response => {
                console.log('friends response', response);
                setFriends(response.data);
                setScore((response.data.length || 0) * APP_PRIZE_COINS.INVITE);
            });
    }, []);

    return <div className="app-friends app-hide-scroll">
        <div className="app-friends--list">
            <h2>Друзья</h2>
            <p>Они уже присоединились к игре<br/> по твоей ссылке.<br/>
            Но чтобы получить баллы за приглашение, друг должен сыграть хотя бы одну игру!<br/>
            За это тебе начислены баллы:</p>
            <Coins coins={score} big={true}/>
            {!friends.length && <div className="app-friends--empty">
                Тут пока никого нет :(<br/> Пригласи друзей в игру!
            </div>}
            {!!friends.length && friends.map((friend, index) => <FriendCard
                key={'friend_card_' + index}
                image={friend.photoPath || profileCardDefault}
                title={((friend.first_name || '') + ' ' + (friend.last_name || '')).trim()}
                coins={friend.score}
            />)}
        </div>
        <div className="app-friends--invite">
            <TaskCard
                image={taskInvite}
                title="Пригласи больше друзей!"
                coins={APP_PRIZE_COINS.INVITE}
                completed={false}
                onClick={() => setPopupName(POPUP_NAME.TASK_INVITE)}
            />
        </div>
        <BottomNav/>
        <div className="app-friends--underlay"/>
        {POPUP_NAME.TASK_INVITE === popupName && <PopupTaskInvite onClose={() => setPopupName(null)}/>}
    </div>;
}